import type { ChatState } from '../state';
import styles from '../styles/timeline.module.css';
import { busyText, TEXT } from '../texts';

/** Connection loss and other consultants at work; the own name is left out, running automations always show. */
export function Banners({ state, ownName }: { state: ChatState; ownName: string }): React.JSX.Element {
  const others = state.presence.filter((entry) => entry.automation === true || entry.name !== ownName);
  return (
    <>
      {!state.connected && (
        <div className={styles.warning} role="status">
          {TEXT.reconnecting}
        </div>
      )}
      {others.map((entry) => (
        <div key={`${entry.automation === true ? 'automation' : 'chat'}-${entry.name}-${entry.chatTitle}`} className={styles.info} role="status">
          ⓘ {entry.automation === true ? TEXT.automationPresence(entry.chatTitle, entry.name) : TEXT.presence(entry.name, entry.chatTitle)}
        </div>
      ))}
    </>
  );
}

export function NoticeLine({ state }: { state: ChatState }): React.JSX.Element | null {
  if (state.notice === null) return null;
  return (
    <div className={styles.warning} role="alert">
      {busyText(state.notice.reason)}
    </div>
  );
}
